import { Component, Vue } from 'vue-property-decorator';

import ComputerHeaderStyle1 from '@/components/computer-header-style-1/computer-header-style-1.component';
import MobileHeader from '@/components/mobile-header/mobile-header.component';
import TabletHeader from '@/components/tablet-header/tablet-header.component';

@Component({
  name: 'error',
  components: {
    ComputerHeaderStyle1,
    MobileHeader,
    TabletHeader,
  },
})
export default class ErrorComponent extends Vue {
  public beforeMount() {
    sessionStorage.clear();
  }
}
